<p>BaseCancellation works!</p>
